import React from 'react';
var COLOR_NORMAL = '#8B8C90';

function DislikeHeart(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$isSelected = _ref.isSelected,
      isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected;
  return (
    /*#__PURE__*/
    React.createElement("svg", {
      "aria-label": "dislike",
      role: "img",
      className: className,
      width: "18",
      viewBox: "0 0 18 18",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /*#__PURE__*/
    React.createElement("path", {
      d: "M0 1.39062L1.06066 0.329965L16.9631 16.2324L15.9025 17.2931L0 1.39062Z",
      fill: COLOR_NORMAL
    }), isSelected ?
    /*#__PURE__*/
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M1.8053 4.19934C0.432042 6.86866 1.61285 11.6733 9.31128 16.9949C10.4421 16.2132 11.4323 15.4427 12.2944 14.6884L1.8053 4.19934ZM14.4607 12.5356C21.5596 4.37856 13.6946 -1.02937 9.31128 3.84291C7.74956 2.107 5.74591 1.67603 4.13451 2.20941L14.4607 12.5356Z" // eslint-disable-line
      ,
      fill: COLOR_NORMAL
    }) :
    /*#__PURE__*/
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M1.8053 4.19934C0.432042 6.86866 1.61285 11.6733 9.31128 16.9949C10.4421 16.2132 11.4323 15.4427 12.2944 14.6884L11.2312 13.6253C10.6575 14.1233 10.0194 14.6334 9.31128 15.1535C6.20168 12.8697 4.44117 10.778 3.55923 9.0535C2.73145 7.43491 2.69541 6.19347 2.95294 5.34698L1.8053 4.19934ZM13.3972 11.4721C14.1406 10.6071 14.6835 9.79625 15.0633 9.0535C16.0159 7.191 15.92 5.82789 15.5349 4.99127C14.8108 3.4182 12.3892 2.66447 10.4264 4.84614L9.31128 6.08565L8.19615 4.84614C7.29715 3.84688 6.30189 3.46343 5.41757 3.49246L4.13451 2.20941C5.41851 1.7844 6.95157 1.97168 8.31164 2.94357C8.65843 3.19139 8.99398 3.49021 9.31128 3.84291C9.62858 3.49021 9.96413 3.19139 10.3109 2.94357C14.7549 -0.232031 21.0457 4.96903 14.4607 12.5356L13.3972 11.4721Z" // eslint-disable-line
      ,
      fill: COLOR_NORMAL
    }))
  );
}

export default DislikeHeart;